import {
  getAnthropicMetadata,
  type AnthropicMetadataCache,
  getAnthropicWorkspaceMetadata,
  type AnthropicWorkspaceCache,
  getAnthropicUserMetadata,
  type AnthropicUserCache
} from '../anthropic-metadata-cache';
import type { DailyAnthropicUsageAggregate, AnthropicUsageAdapterOptions } from './types';
import { MS_PER_DAY } from './constants';

export const createAnthropicDailyAggregate = (dayKey: string): DailyAnthropicUsageAggregate => ({
  date: dayKey,
  requests: 0,
  cost: 0,
  contextTokens: 0,
  generatedTokens: 0,
  cachedTokens: 0,
  models: {},
  uniqueApiKeys: 0,
  apiKeys: new Set<string>(),
  totalTokens: 0,
  modelTokenSums: {},
  modelRequestEstimates: {},
  provider: 'anthropic',
  isEstimatedRequests: true,
  breakdowns: {
    anthropic: {
      provider: 'anthropic',
      requests: 0,
      cost: 0,
      contextTokens: 0,
      generatedTokens: 0,
      cachedTokens: 0,
      isEstimatedRequests: true
    }
  }
});

export const determineRank = (requests: number, days: number): string => {
  const diffDays = Math.max(1, days);
  const adjustedDailyAverage = requests / diffDays;

  if (adjustedDailyAverage >= 40 || requests >= 2000) return 'SSS';
  if (adjustedDailyAverage >= 20 || requests >= 1000) return 'SS';
  if (adjustedDailyAverage >= 10 || requests >= 500) return 'S';
  if (adjustedDailyAverage >= 5 || requests >= 200) return 'A';
  if (adjustedDailyAverage >= 2.5 || requests >= 100) return 'B';
  if (diffDays === 1 && requests < 2) return 'D';
  return 'C';
};

export const ensureMetadataCache = async (credentialRevision?: string): Promise<AnthropicMetadataCache> => {
  return getAnthropicMetadata({ credentialRevision });
};

export const ensureWorkspaceCache = async (credentialRevision?: string): Promise<AnthropicWorkspaceCache> => {
  return getAnthropicWorkspaceMetadata({ credentialRevision });
};

export const ensureUserCache = async (credentialRevision?: string): Promise<AnthropicUserCache> => {
  return getAnthropicUserMetadata({ credentialRevision });
};

export const getDefaultRange = (): AnthropicUsageAdapterOptions => {
  const endDate = new Date();
  const startDate = new Date(endDate.getTime() - 30 * MS_PER_DAY);
  return { startDate, endDate, label: 'last30Days' };
};
